export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        defaultValue: {
            default: false,
            type: [Boolean, String],
        },
        disabled: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        name: {
            required: true,
            type: String,
        },
        refreshFields: {
            type: Number,
        },
        type: {
            default: 'checkbox',
            type: String,
        },
        value: {
            type: [Boolean, Number],
            default: null,
        },
        focus: {
            default: false,
            type: Boolean,
        },
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        /**
         * Initializes the bootstrapSwitch plug-in
         *
         * @return  {void}
         */
        initializeBootstrapSwitch() {
            const $booleanSwitch = $(this.$el).find('input');

            const state = this.value === null ? !!parseInt(this.defaultValue) : this.value;

            $booleanSwitch.bootstrapSwitch({
                state,
            });

            $booleanSwitch.off('switchChange.bootstrapSwitch');

            $booleanSwitch.on(
                'switchChange.bootstrapSwitch',
                function (event, state) {
                    this.$emit('change', {
                        event,
                        id: this.id,
                        name: this.name,
                        value: state,
                    });
                }.bind(this)
            );
        },

        /**
         * Sets a component value to defaultValue, if required
         *
         * @return  {void}
         */
        setDefaultValueIfRequired() {
            if (this.value === null && this.defaultValue) {
                this.$emit('change', {
                    id: this.id,
                    name: this.name,
                    value: !!parseInt(this.defaultValue),
                });
            }
        },
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.$nextTick(() => {
            this.setDefaultValueIfRequired();

            this.initializeBootstrapSwitch();
            if (this.focus) {
                $(this.$el).find(`#${this.id}`).focus();
            }
        });
    },

    /**
     * Set the beforeDestroy hook
     *
     * @return  {void}
     */
    beforeDestroy() {
        $(this.$el).find('input').bootstrapSwitch('destroy');
    },

    /**
     * Set the watched properties
     *
     * @type  {Object}
     */
    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                this.setDefaultValueIfRequired();

                this.$nextTick(() => {
                    this.$forceUpdate();

                    $(this.$el).find('input').bootstrapSwitch('destroy');

                    this.initializeBootstrapSwitch();
                });
            }
            if (this.focus) {
                this.$nextTick(() => {
                    $(this.$el).find(`#${this.id}`).focus();
                });
            }
        },
    },
};
